import { Injectable } from '@angular/core';
import { AppConfig } from '../app.config';
import { throwError } from 'rxjs';
import { filter, map, catchError } from 'rxjs/operators';
import { HelpersService } from './helpers.service';
import { HttpClient } from '@angular/common/http';
import { ErrorHandlerService } from './errorhandler.service';// Add this for error feedback
 
@Injectable({
  providedIn: 'root',
})
export class DashboardService {
  private apiURL: string = '';
  private env: any;

  constructor(
    private http: HttpClient,
    private appConfig: AppConfig,
    private helpersService: HelpersService, 
    private errorHandler: ErrorHandlerService,// Add this for error feedback
  ) {
    this.apiURL = this.appConfig.getEnvironment();
    this.env = this.appConfig.getEnvironmentNew();
  }

  getPartnerDashboardInfo(partnerId: string) {
    let requestOptions = this.helpersService.getAuthenticatedRequestOptions();
    return this.http
      .get(
        this.apiURL + '/api/Partner/' + partnerId + '/DashboardInfo',
        requestOptions,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.statusText);
        }),
      );
  }

  getPartnerDashboardInfoV2(partnerIds: string) {
    let requestOptions = this.helpersService.getAuthenticatedRequestOptions();
    return this.http
      .get(
        this.apiURL + '/api/Partner/' + partnerIds + '/DashboardInfoV2',
        requestOptions,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.statusText);
        }),
      );
  }

  getDashboardInfoServiceWithinKm(partnerId: string, km: number) {
    let requestOptions = this.helpersService.getAuthenticatedRequestOptions();
    return this.http
      .get(
        this.apiURL +
          `/api/Partner/${partnerId}/GetCyclistDashboardInfo/${km}/ServiceWithinKm`,
        requestOptions,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.statusText);
        }),
      );
  }

  getDashboardInfoServiceWithinHours(partnerId: string, hours: number) {
    let requestOptions = this.helpersService.getAuthenticatedRequestOptions();
    return this.http
      .get(
        this.apiURL +
          `/api/Partner/${partnerId}/GetCyclistDashboardInfo/${hours}/ServiceWithinHours`,
        requestOptions,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.statusText);
        }),
      );
  }

  getDashboardInfoServicedMonthsAgo(partnerId: string, months: number) {
    let requestOptions = this.helpersService.getAuthenticatedRequestOptions();
    return this.http
      .get(
        this.apiURL +
          `/api/Partner/${partnerId}/GetCyclistDashboardInfo/${months}/ServicedMonthsAgo`,
        requestOptions,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.statusText);
        }),
      );
  }

  getDashboardInfoServicedMonthInterval(partnerId: string) {
    let requestOptions = this.helpersService.getAuthenticatedRequestOptions();
    return this.http
      .get(
        this.apiURL +
          `/api/Partner/${partnerId}/GetCyclistDashboardInfo/ServiceWithinMonthInterval`,
        requestOptions,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.statusText);
        }),
      );
  }

  getPartnerDashboardData(partnerId: string, dashboardName: string) {
    let requestOptions = this.helpersService.getAuthenticatedRequestOptions();
    return this.http
      .get(
        this.apiURL +
          `/api/Partner/${partnerId}/DashboardData/${dashboardName}`,
        requestOptions,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.statusText);
        }),
      );
  }

  getServiceDueSummary(partnerId: string) {
    let requestOptions = this.helpersService.getAuthenticatedRequestOptions();
    return this.http
      .get(
        this.apiURL + `/api/Partner/${partnerId}/ServicesDueSummary`,
        requestOptions,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.statusText);
        }),
      );
  }

  getServiceDueDetail(partnerId: string) {
    let requestOptions = this.helpersService.getAuthenticatedRequestOptions();
    return this.http
      .get(
        this.apiURL + `/api/Partner/${partnerId}/ServicesDueDetail`,
        requestOptions,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.statusText);
        }),
      );
  }

  getDailyWorkshopSummary(partnerID, date) {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .get(
        this.env.url +
          `/Reports/GetWorkshopDailySummary/${partnerID}?date=${date}&code=` +
          this.env.key,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res);
        }),
      );
  }
}
